/**
 * RTWO Cryptography & Identity Engine — Secure Enclave Key Provider (Scaffold)
 */

import { ScaffoldKeyProvider } from './scaffold-key-provider';

export class SecureEnclaveKeyProvider extends ScaffoldKeyProvider {
  readonly providerId = 'secure-enclave-key-provider';
  readonly providerName = 'Secure Enclave Key Provider';
  readonly providerType = 'secure_enclave' as const;
  readonly scaffoldMessage =
    'Secure Enclave key provider scaffold. Enclave connection not implemented — cryptographic operations unavailable.';
}
